import Card from '@berlitz/card'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  svg {
    height: ${({ theme }) => theme.layout.xxs};
    width: ${({ theme }) => theme.layout.xxs};
  }

  .ant-timeline-item-head-custom {
    padding: 0 1px;
  }
`

interface HeaderProps {
  hideHeaderOnLg?: boolean
}

export const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.palette.gray40};
  margin-right: -${({ theme }) => theme.space.lg};
  margin-left: -${({ theme }) => theme.space.lg};
  padding: ${({ theme }) => `0 ${theme.space.lg} ${theme.space.xs} ${theme.space.lg}`};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: ${({ theme }) => theme.fontSize.lg};
    border-bottom: none;
    ${(props: HeaderProps) =>
      props.hideHeaderOnLg &&
      css`
        display: none;
        margin-bottom: 0;
      `}

  svg {
    height: ${({ theme }) => theme.layout.sm};
    width: ${({ theme }) => theme.layout.sm};
    margin-right: ${({ theme }) => theme.space.sm};
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      display: flex;
    }
  }
`

// @ts-ignore
export const WrapperCard = styled(Card)`
  box-shadow: none;
  > div {
    padding: 0;
  }
  overflow: inherit;
  // @ts-ignore
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    // @ts-ignore
    padding-bottom: ${({ theme }) => theme.space.md};
  }
`
